export default __webpack_public_path__ + "static/media/gloves_of_tribulation.ec0ad889.jpg";